import * as React from "react";

export const Hours = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 2.60002C5.01756 2.60002 2.5999 5.01769 2.5999 8.00002C2.5999 10.9824 5.01756 13.4 7.9999 13.4C10.9822 13.4 13.3999 10.9824 13.3999 8.00002C13.3999 5.01769 10.9822 2.60002 7.9999 2.60002ZM1.3999 8.00002C1.3999 4.35494 4.35482 1.40002 7.9999 1.40002C11.645 1.40002 14.5999 4.35494 14.5999 8.00002C14.5999 11.6451 11.645 14.6 7.9999 14.6C4.35482 14.6 1.3999 11.6451 1.3999 8.00002ZM7.9999 4.90002C8.33127 4.90002 8.5999 5.16865 8.5999 5.50002V8.67891L9.83272 9.50079C10.1084 9.68461 10.1829 10.0571 9.99913 10.3328C9.81532 10.6086 9.4428 10.6831 9.16708 10.4993L7.66708 9.49926C7.50016 9.38798 7.3999 9.20064 7.3999 9.00002V5.50002C7.3999 5.16865 7.66853 4.90002 7.9999 4.90002Z"
    />
);
